module.exports = {
  // Темы для глобальных событий
  topics: {
    // Новый заказ
    order: 'order',
  },
  // Типы для таргетированных (по токену)
  types: {
    // Новое сообщение в чате
    chat: 'chat',

    // Чат прочитан
    chat_read: 'chat:read',

    // Общий тип для уведомлений, которые показываются в приложении в списке уведомлений
    notification: 'notification',

    // Новый подходящий заказ
    new_order: 'new_order',

    // Новый заказ по избранному
    bookmark_new_order: 'new_order:bookmark',

    // Статусы документов
    document_confirm: 'document:confirm',
    document_refuse: 'document:refuse',
    document_expiring: 'document:expiring',
  },
};
